import { API_URL } from "./Config";
import { PageResult } from "./Pagination";

export const GetRelatedDocumentsFetchUrl = (
  regardingObjectId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/Document/listbyregardingobjectid?regardingobject_id=${regardingObjectId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents`;
  }

  return url;
};

export interface IDocumentsColumnFilter {
  name: string;
  value: string;
}

export interface IDocumentsColumnFilterList {
  list: IDocumentsColumnFilter[];
}

export async function GetLicenseCreatedByFilterAsync(
  licenceId: string
): Promise<IDocumentsColumnFilterList> {
  let url = `${API_URL}/Document/searchcreatedbyfilter?licence_id=${licenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents-licence-created-by-filter`;
  }

  var response = await fetch(url);
  var body = <IDocumentsColumnFilterList>await response.json();
  body.list = body.list.map((item) => {
    return <IDocumentsColumnFilter>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetLicenseClassificationFilterAsync(
  licenceId: string
): Promise<IDocumentsColumnFilterList> {
  let url = `${API_URL}/Document/searchclassificationfilter?licence_id=${licenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents-licence-classification-filter`;
  }

  var response = await fetch(url);
  var body = <IDocumentsColumnFilterList>await response.json();
  body.list = body.list.map((item) => {
    return <IDocumentsColumnFilter>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetLicenseSubClassificationFilterAsync(
  licenceId: string
): Promise<IDocumentsColumnFilterList> {
  let url = `${API_URL}/Document/searchsubclassificationfilter?licence_id=${licenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents-licence-subclassification-filter`;
  }

  var response = await fetch(url);
  var body = <IDocumentsColumnFilterList>await response.json();
  body.list = body.list.map((item) => {
    return <IDocumentsColumnFilter>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export const GetFilteredLicenceDocumentsFetchUrl = (
  notifierId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `?licence_id=${notifierId}&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Document/listbylicenceidfullfiltered${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents`;
  }

  return url;
};
